let collectionList = document.querySelector('.js-collections-list');

let collectionListParent = collectionList.querySelectorAll('nav > ul > li'),
    collectionListImages = collectionList.querySelectorAll('.image');


collectionListParent.forEach((elem, i) => {

    let image = collectionListImages[i];

    if (image) {
      let img = image.querySelector('img');

      elem.addEventListener("mouseover", mOver, false);
      elem.addEventListener("mouseout", mOut, false);

      function mOver() {
        collectionListParent.forEach(elem => { elem.classList.remove('active') });
        collectionListImages.forEach(image => { image.classList.remove('active') });
        image.classList.add('active');
        elem.classList.add('active');

        return false;
        this.classList.add("active");
      }

      function mOut() {
        this.classList.remove("active");
        image.classList.remove("active");
        return false;
      }

      elem.addEventListener('mousemove', (e) => {
        image.style.top = (e.offsetY - (img.height / 2)) + "px";
        image.style.left = (e.offsetX - (img.width / 2)) + "px";
        image.style.right = (e.offsetX - (img.width / 2)) + "px";
      });
    } else {
      elem.addEventListener("mouseover", mOver, false);
      elem.addEventListener("mouseout", mOut, false);

      function mOver() {
        collectionListParent.forEach(elem => { elem.classList.remove('active') });
        collectionListImages.forEach(image => { image.classList.remove('active') });
        elem.classList.add('active');

        return false;
        this.classList.add("active");
      }

      function mOut() {
        this.classList.remove("active");
        return false;
      }
    }

});
